<template>
  <ion-page>
    <ion-header mode="ios" class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start" hide-back-button="true">
          <ion-back-button text="" default-href="" @click="$emit('closeModal')"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="header">
      <div class="title">
        <ion-text class="fw-500">{{ $t('companies_with_postal_code') }} "{{ postalCode }}"</ion-text>
        <ion-text>{{ $t('one_or_more_company') }}.</ion-text>
      </div>
    </div>
    <div class="content-tr ion-margin-top">
      <ion-text>{{ $t('customerPage.company_name') }}</ion-text>
      <ion-text>{{ userData.user_type_id === 7 ? $t('salesperson') : '' }}</ion-text>
    </div>
    <ion-content>
      <div class="content-td">
        <div>
          <ion-list>
            <ion-radio-group mode="ios">
              <div class="list-company" v-for="(data, index) in dataCheckDuplicateCustomer" :key="index">
                <div class="list-info">
                  <ion-item>
                    <ion-radio
                      :class="[
                        'ion-margin-start',
                        data.is_branch || (data.CustomerTenant?.length && !data.CustomerTenant[0].active)
                          ? 'ion-radio-disable'
                          : ''
                      ]"
                      slot="start"
                      @click="setCustomerId(data)"
                      :value="data.id"
                    ></ion-radio>
                    <div class="list-info-header">
                      <div class="list-info-title">
                        <ion-label
                          :class="[
                            data.is_branch || (data.CustomerTenant?.length && !data.CustomerTenant[0].active)
                              ? 'blur-title'
                              : ''
                          ]"
                          >{{ data.name }}</ion-label
                        >
                      </div>

                      <div
                        class="list-info-title"
                        v-if="
                          data.is_branch || (data.CustomerTenant?.length && !data.CustomerTenant[0].active)
                        "
                      >
                        <ion-label
                          @click="handleCannotConect(data)"
                          class="list-cannot-connect ion-text-right"
                        >
                          <ion-text>{{ $t('cannot_connect') }}</ion-text>
                          <img :src="Vector" />
                        </ion-label>
                      </div>

                      <div class="list-info-title" v-if="!data.is_branch">
                        <ion-row class="ion-align-items-center mr-2">
                          <icon-label
                            :class="['mr-1', data.CustomerTenant?.length ? 'text-primary' : 'text-danger']"
                          >
                            {{ data.CustomerTenant?.length ? $t('connected') : $t('not_connected') }}
                          </icon-label>

                          <ion-chip v-if="data.is_b2c" class="b2c-label-chip my-0">B2C</ion-chip>
                        </ion-row>

                        <ion-label class="ion-text-right">
                          {{ getSupplierContactPersonName(data) }}
                        </ion-label>
                      </div>

                      <div
                        :class="[
                          'list-info-address',
                          data.is_branch || (data.CustomerTenant?.length && !data.CustomerTenant[0].active)
                            ? 'blur-title'
                            : ''
                        ]"
                      >
                        <ion-text>{{
                          !data.addresses[0] ? ' ' : getAddressFormatWithStall(data.addresses[0])
                        }}</ion-text>
                      </div>
                    </div>
                  </ion-item>
                </div>
              </div>
            </ion-radio-group>
          </ion-list>
        </div>
      </div>
    </ion-content>
    <ion-footer>
      <div class="footer">
        <div class="ion-margin-bottom ion-margin-top">
          <ion-label>{{ $t('is_the_company_you_want') }}</ion-label>
        </div>
        <ion-button expand="block" class="ion-text-wrap" fill="outline" @click="$emit('closeModal')">{{
          $t('no_continue_adding_new_company')
        }}</ion-button>
        <ion-button
          expand="block"
          class="ion-text-wrap"
          color="primary"
          @click="connectSalesToCustomer"
          v-show="customerId && canConnectCustomer"
          >{{ $t('yes_connect_to_existing_company') }}</ion-button
        >
        <ion-button
          expand="block"
          class="ion-text-wrap"
          color="primary"
          @click="replaceAsContactPerson"
          v-show="customerId && !canConnectCustomer && canTakeOverCustomer"
          >{{ $t('yes_replace_as_contact_person') }}</ion-button
        >
      </div>
    </ion-footer>
  </ion-page>
</template>

<script>
import Vector from '@/assets/images/Vector.png';
import { apolloClient } from '@/main';
import { getAddressFormatWithStall } from '@/modules/b2b/services/libs/helper';
import {
  saleAddCustomer,
  saleCheckCanTakeOverCustomer,
  saleReplaceContactPerson
} from '@/modules/sale/services/graphql';
import { alertController, toastController } from '@ionic/vue';
export default {
  props: ['dataCheckDuplicateCustomer', 'postalCode'],
  inject: ['$storage'],
  setup() {
    const openToast = async function (message) {
      const toast = await toastController.create({
        message,
        position: 'top',
        color: 'primary',
        duration: 2000
      });
      return toast.present();
    };
    return {
      getAddressFormatWithStall,
      openToast,
      Vector
    };
  },
  data() {
    return {
      userData: [],
      customerId: 0,
      canTakeOverCustomer: false,
      canConnectCustomer: false
    };
  },
  async mounted() {
    this.userData = await this.$storage.getUser();
  },
  methods: {
    async handleCannotConect(payload) {
      let message = '';
      if (payload.is_branch) {
        message = this.$t('handle_not_connect_mess_branch', { customer_name: payload.name });
      }

      if (!payload.CustomerTenant?.[0]?.active) {
        message = this.$t('handle_not_connect_mess_inactive_customer', {
          customer_name: payload.name,
          tenant_name: payload.CustomerTenant?.[0].tenant_name
        });
      }

      const alert = await alertController.create({
        mode: 'ios',
        cssClass: 'custom-alertDanger',
        header: this.$t('unable_to_connect'),
        message: message,
        backdropDismiss: false,
        buttons: [
          {
            text: this.$t('OK'),
            handler: payload.is_branch
              ? async () => {
                  this.$emit('handleBackCustomerPage');
                }
              : undefined
          }
        ]
      });
      await alert.present();
    },
    async setCustomerId(customer) {
      this.customerId = customer.id;
      this.canConnectCustomer = !customer.userCustomers?.length;
      await this.checkCanTakeOverCustomer(customer);
    },
    async checkCanTakeOverCustomer(customer) {
      if (
        customer.userCustomers?.find((userCustomer) => userCustomer.user?.id === Number(this.userData.id))
      ) {
        this.canTakeOverCustomer = false;
        return;
      }

      try {
        const { data, errors } = await apolloClient.query({
          query: saleCheckCanTakeOverCustomer,
          variables: {
            customerId: Number(this.customerId),
            tenantId: this.userData.tenant.id
          }
        });
        if (errors) {
          this.presentAlert(errors[0].message);
          return;
        } else {
          this.canTakeOverCustomer = data.saleCheckCanTakeOverCustomer;
        }
      } catch (error) {
        this.presentAlert(error.message);
      }
    },
    async connectSalesToCustomer() {
      try {
        const { errors } = await apolloClient.mutate({
          mutation: saleAddCustomer,
          variables: {
            item: {
              customer_id: Number(this.customerId),
              tenant_id: this.userData.tenant.id
            }
          }
        });
        if (errors) {
          this.presentAlert(errors[0].message);
          return;
        } else {
          const message = this.$t('successfully_connected_to_company');
          await this.openToast(message);
          this.$emit('handleBackCustomerPage');
        }
      } catch (error) {
        this.presentAlert(error.message);
      }
    },
    async replaceAsContactPerson() {
      try {
        const { errors } = await apolloClient.mutate({
          mutation: saleReplaceContactPerson,
          variables: {
            tenantId: this.userData.tenant.id,
            customerId: Number(this.customerId),
            userId: this.userData.id
          }
        });
        if (errors) {
          this.presentAlert(errors[0].message);
          return;
        } else {
          const message = this.$t('success_replace_contact_person');
          await this.openToast(message);
          this.$emit('handleBackCustomerPage');
        }
      } catch (error) {
        this.presentAlert(error.message);
      }
    },
    async presentAlert(params) {
      if (this.customerId === '') {
        return;
      } else {
        const alert = await alertController.create({
          mode: 'ios',
          cssClass: 'custom-alertDanger',
          header: this.$t('unable_to_connect'),
          message: params,
          backdropDismiss: false,
          buttons: [
            {
              text: this.$t('OK')
            }
          ]
        });
        await alert.present();
      }
    },
    getSupplierContactPersonName(customer) {
      return [customer?.userCustomers?.[0]?.user?.first_name, customer?.userCustomers?.[0]?.user?.last_name]
        .filter(Boolean)
        .join(' ');
    }
  }
};
</script>

<style src="../styles/ModalSearchPostalCode.scss" lang="scss" scoped></style>
